import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import logo from '../../Assests/6cc50dfbdb85cec604c94e003196fcb318fb231a.png'
// import logoBanner from '../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import './Home.css'
import ProductInfo from "../../Components/ProductInfo/ProductInfo";
import { NavLink, useLocation } from "react-router-dom";
import Category from "../../Components/Category/Category";
import { urlApiServer, urlApiServerImage } from "../../Config/Config";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import BannerCarousel from "./BannerCarousel/BannerCarousel";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import { fetchWithCache } from "../../utils/cacheService";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

function Home() {

    const [selectProduct, setSelectProduct] = useState(false);
    const [selectCategory, setSelectCategory] = useState(false);
    const [infoProduct, setInfoProduct] = useState();
    const [infoCategory, setInfoCategory] = useState();
    const [categorys, setCategorys] = useState([]);
    const [product, setProduct] = useState([]);
    const [background, setBackground] = useState([]);
    const [backgroundCollection, setBackgroundCollection] = useState([]);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [campaignData, setCampaignData] = useState(null);
    const [brochureData, setBrochureData] = useState([]);
    const location = useLocation(); // Obtén la ubicación actual

    const urlGetCategorys = `${urlApiServer}categorias?populate=*`
    const urlGetProducts = `${urlApiServer}productos?populate=*`
    const urlGetfrontPageHomes = `${urlApiServer}front-page-homes?populate=*`
    const urlGetbrochure = `${urlApiServer}brochure-digitals?populate=*`
    const urlGetcollectionCovers = `${urlApiServer}collection-covers?populate=*`
    const urlGetCampaigns = `${urlApiServer}campaigns?populate=*`

    const categoryScrollRef = useRef(null);

    // Definir funciones de manejo antes de usarlas en useEffect
    const handleProduct = useCallback((e) => {
        setSelectProduct(true);
        setInfoProduct(e);
    }, []);

    const handleCategory = useCallback((e) => {
        setSelectCategory(true);
        setInfoCategory(e);
    }, []);

    const handleCategoryScroll = useCallback((direction) => {
        if (categoryScrollRef.current) {
            const scrollAmount = 300; // Cantidad de scroll
            categoryScrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    }, []);

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        // Verifica si hay una categoría en el estado de navegación
        if (location.state?.category) {
            handleCategory(location.state.category);
        } else if (location.state?.product) {
            handleProduct(location.state.product)
        }
    }, [location.state, handleCategory, handleProduct]);


    // Efecto para verificar la posición del scroll
    useEffect(() => {
        const checkScrollPosition = () => {
            if (categoryScrollRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = categoryScrollRef.current;
                const isAtStart = scrollLeft <= 10; // Pequeña tolerancia
                const isAtEnd = scrollLeft >= scrollWidth - clientWidth - 10; // Pequeña tolerancia

                setCanScrollLeft(!isAtStart);
                setCanScrollRight(!isAtEnd);
            }
        };

        // Verificar inmediatamente al montar
        checkScrollPosition();

        // Agregar event listener para scroll
        const currentRef = categoryScrollRef.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', checkScrollPosition);
        }

        // También verificar cuando cambien las categorías o el tamaño de la ventana
        window.addEventListener('resize', checkScrollPosition);

        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', checkScrollPosition);
            }
            window.removeEventListener('resize', checkScrollPosition);
        };
    }, [categorys]);


    useEffect(() => {
        // Función helper para hacer fetch con caché
        const fetchData = async (url) => {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                // Usar fetchWithCache que maneja el caché automáticamente
                return await fetchWithCache(url, requestOptions);
            } catch (error) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Error fetching data from:', url);
                }
                return null;
            }
        };

        // Paralelizar todas las llamadas API para mejorar el rendimiento
        // El caché se aplica automáticamente en fetchWithCache
        Promise.all([
            fetchData(urlGetCategorys),
            fetchData(urlGetProducts),
            fetchData(urlGetfrontPageHomes),
            fetchData(urlGetbrochure),
            fetchData(urlGetcollectionCovers),
            fetchData(urlGetCampaigns)
        ]).then(([categoryResponse, productResponse, frontPageResponse, brochureResponse, collectionResponse, campaignResponse]) => {
            // Procesar categorías
            if (categoryResponse?.data && Array.isArray(categoryResponse.data)) {
                setCategorys(categoryResponse.data.reverse());
            } else {
                setCategorys([]);
            }

            // Procesar productos
            if (productResponse?.data && Array.isArray(productResponse.data)) {
                setProduct(productResponse.data);
            } else {
                setProduct([]);
            }

            // Procesar fondos de página
            if (frontPageResponse?.data && frontPageResponse.data.length > 0 && Array.isArray(frontPageResponse.data[0].portada)) {
                setBackground(frontPageResponse.data[0].portada.reverse());
            } else {
                setBackground([]);
            }

            // Procesar brochure
            if (brochureResponse?.data && Array.isArray(brochureResponse.data) && brochureResponse.data.length > 0) {
                const brochureImages = brochureResponse.data
                    .flatMap(item => item.Bronchure || [])
                    .filter(img => img != null);
                setBrochureData(brochureImages);
            } else {
                setBrochureData([]);
            }

            // Procesar colecciones
            if (collectionResponse?.data && Array.isArray(collectionResponse.data)) {
                setBackgroundCollection(collectionResponse.data.reverse());
            } else {
                setBackgroundCollection([]);
            }

            // Procesar campañas
            if (campaignResponse?.data && Array.isArray(campaignResponse.data) && campaignResponse.data.length > 0) {
                setCampaignData(campaignResponse.data[0]);
            } else {
                setCampaignData(null);
            }
        });
    }, [urlGetCategorys, urlGetProducts, urlGetfrontPageHomes, urlGetcollectionCovers, urlGetCampaigns, urlGetbrochure]);

    // Memoizar cálculos costosos para evitar re-renders innecesarios
    const featuredProducts = useMemo(() => 
        product.filter(item => item.Destacado === true),
        [product]
    );

    const currentYearProducts = useMemo(() => {
        const currentYear = new Date().getFullYear();
        return product.filter(item => {
            const publishedYear = new Date(item.ano_de_la_coleccion).getFullYear();
            return publishedYear === currentYear;
        });
    }, [product]);

    return (
        <div>
            {(selectProduct === false) ? (
                (selectCategory === false) ? (
                    <>
                        {/* <div className="bannerContainer" style={{ backgroundImage: `url(${urlApiServerImage + background[0]?.portada?.url})` }}>
                            <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                        </div> */}
                        <BannerCarousel background={background} urlApiServerImage={urlApiServerImage} />
                        <div className="latestCreationsContainer">
                            <div className="textLatestCreationsContainer">
                                <p className="textLatestCreations">ULTIMAS CREACIONES</p>
                            </div>
                            <div className="productGrid">
                                {product.map(item => (
                                    <div key={item.id} className="productCard" onClick={() => handleProduct(item)}>
                                        <img 
                                            src={urlApiServerImage + item.Imagenes[0].url} 
                                            alt={item.Nombre} 
                                            className="productImage"
                                            loading="lazy"
                                        />
                                        <p className="productTitle">{item.Nombre}</p>
                                        <p className="productID">ID {item.id}</p>
                                        {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="textCategoryProductsContainer">
                            <p className="textCategoryProducts">CATEGORIAS</p>
                        </div>
                        <div className="categorySection">

                            <div className="categoryContainer">
                                {canScrollLeft && (
                                    <div
                                        className="navArrowLeft"
                                        onClick={() => handleCategoryScroll('left')}
                                        aria-label="Desplazar categorías a la izquierda"
                                    >
                                        <FaChevronLeft size={20} className="arrowIconCategory" />
                                    </div>
                                )}
                                <div
                                    className="categoryCardsWrapper"
                                    ref={categoryScrollRef}
                                    id="autoScroll"
                                >
                                    {categorys.map((item, index) => (
                                        <div
                                            key={item.id}
                                            className="categoryCard"
                                            style={{ backgroundImage: `url(${urlApiServerImage + item.portada.url})` }}
                                            onClick={() => handleCategory(item)}
                                        >
                                            <div className="categoryText">{item.Nombre}</div>
                                        </div>
                                    ))}
                                </div>
                                {canScrollRight && (
                                    <div
                                        className="navArrowRight"
                                        onClick={() => handleCategoryScroll('right')}
                                        aria-label="Desplazar categorías a la derecha"
                                    >
                                        <FaChevronRight size={20} className="arrowIconCategory" />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="featuredProductsContainer">
                            <div className="textfeaturedProductsContainer">
                                <p className="textfeaturedProducts">PRODUCTOS DESTACADOS</p>
                            </div>
                            <div className="productGrid">
                                {featuredProducts.map(item => (
                                    <div key={item.id} className="productCard" onClick={() => handleProduct(item)}>
                                        <img 
                                            src={urlApiServerImage + item.Imagenes[0].url} 
                                            alt={item.Nombre} 
                                            className="productImage"
                                            loading="lazy"
                                        />
                                        <p className="productTitle">{item.Nombre}</p>
                                        <p className="productID">ID {item.id}</p>
                                        {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {brochureData.length > 0 && (
                            <div 
                                className="brochureDigitalSection"
                                style={{
                                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(/assets/images/brochureDig2026.jpg)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                                <div className="brochureDigitalSectionContent">
                                    <h2 className="brochureDigitalSectionTitle">BROCHURE DIGITAL 2026</h2>
                                    <p className="brochureDigitalSectionText">Descubre todo lo que tenemos para ti en este 2026</p>
                                    <NavLink to="/BrochureDigital" className="brochureDigitalSectionLink">
                                        <button className="brochureDigitalSectionButton">
                                            VER
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        )}
                        {/* Imágenes Section */}
                        {campaignData && (
                            <div className="imagesSection">
                                <div className="imagesHeader">
                                    <h2 className="imagesTitle">{campaignData.Titulo || 'CAMPAÑA 2026'}</h2>
                                    {campaignData.texto && campaignData.texto.trim() !== '' && (
                                        <p className="imagesText">{campaignData.texto}</p>
                                    )}
                                </div>
                                <div className="imagesCarousel">
                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        centeredSlides={true}
                                        loop={true}
                                        slidesPerView={'auto'}
                                        coverflowEffect={{
                                            rotate: 15,
                                            stretch: 0,
                                            depth: 300,
                                            modifier: 1.5,
                                            slideShadows: true,
                                        }}
                                        navigation={true}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[EffectCoverflow, Navigation, Pagination]}
                                        className="imagesSwiper"
                                    >
                                    {campaignData.Galeria && campaignData.Galeria.map((image, index) => (
                                        <SwiperSlide key={index} className="imagesSlide">
                                            <img 
                                                src={urlApiServerImage + image.url} 
                                                alt={`${campaignData.Titulo} - ${index + 1}`}
                                                loading="lazy"
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                        )}

                        <div className="collectionContainer">
                            <div className="collectionBannerContainer" style={{ backgroundImage: `url(${urlApiServerImage + backgroundCollection[0]?.portada?.url})` }}>
                                <div className="infoBannerCollectionContainer">
                                    <div className="logoCollectionBannerContainer">
                                        <div className="logoCollectionBannerContainer">
                                            <img src={logo} alt="logo" className="logoCollectionBanner" />
                                        </div>
                                        <div className="textLogoCollectionBannerContainer">
                                            <p className='textLogoCollectionBanner'>COLECCION {new Date().getFullYear()}</p>
                                        </div>
                                    </div>
                                    <div className="markYourStyleCollectionBannerContainer">
                                        <p className="markYourStyleCollectionBanner">MARCA TU ESTILO CON LA NUEVA COLECCIÓN {new Date().getFullYear()}</p>
                                    </div>
                                    <div className="buyButtonCollectionBannerContainer">
                                        <NavLink to="/Collecciones" className="activeNav">
                                            <div className="buyButtonCollectionBanner">
                                                <p className="textBuyButtonCollection">COMPRAR</p>
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="collectionCatalogContainer">
                                <div className="productGrid">
                                    {currentYearProducts.map(item => (
                                            <div key={item.id} className="productCard" onClick={() => handleProduct(item)}>
                                                <img 
                                                    src={urlApiServerImage + item.Imagenes[0].url} 
                                                    alt={item.Nombre} 
                                                    className="productImage"
                                                    loading="lazy"
                                                />
                                                <p className="productTitle">{item.Nombre}</p>
                                                <p className="productID">ID {item.id}</p>
                                                {item.Mostrar_Precio && <p className="productPrice">Desde $ {item.precio} USD</p>}
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </>
                ) : (<Category Category={infoCategory} background={urlApiServerImage + background[0]?.url} product={product} onClose={() => setSelectCategory(false)} />)
            ) : (
                <ProductInfo product={infoProduct} products={product} background={urlApiServerImage + background[0]?.url} onClose={() => setSelectProduct(false)} />
            )}
        </div>
    )
}

export default Home